import { createContext, useContext } from 'react';

export type LanguageInfoDialogType = {
  isDialogOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
};

const LanguageInfoDialogContext = createContext<LanguageInfoDialogType>({
  isDialogOpen: false,
  openDialog: () => {},
  closeDialog: () => {},
});

export const useLanguageInfoDialog = () => {
  const context = useContext(LanguageInfoDialogContext);
  if (!context) {
    throw new Error('useLanguageDialog must be used within a LanguageDialogProvider');
  }
  return context;
};

export default LanguageInfoDialogContext;
